import {Validators} from '@angular/forms';
import {replacePayload} from '@core/form/replacePayload';

export const email = (message: string = 'errors.email') => replacePayload(Validators.email, (payload) => ({
  message,
  payload
}));
